<template>
  <div>
    <!-- Верхняя часть -->
    <div class="text-subtitle-2 grey--text">Задача :#{{ data.id }}</div>
    <div class="d-flex justify-space-between align-center mb-2">
      <div class="text-subtitle-2 grey--text">Создано:<a-view-datetime :value="data.createdon" /></div>
      <div class="text-subtitle-2" :class="deadlineClass">Срок: <a-view-datetime :value="data.eventon" /></div>
    </div>
    <!-- Описание -->
    <div v-if="data.actions.length">
      <div v-for="item in data.actions" :key="item.id">
        <component :key="item.id_" :is="`lead-action`" :data="item" />
        <hr class="mb-1 mt-1" />
      </div>
    </div>
    <div class="text-body-1 mb-4">
      <div class="text-subtitle-2">{{ task_template.name }}</div>
      {{ data.comment || task_template.description }}
    </div>

    <!-- Результат -->
    <lead-btn-result v-if="getAccess('leads.actions.create')" :items="results" @click="$emit('result', $event)" />
  </div>
</template>

<script>
import { getAccess, popupMenu, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, popupMenu, genModel],
  components: {},
  props: {
    data: Object,
    result: Object,
  },
  data() {
    return {
      task_template: {},
      results: [],
    };
  },
  async created() {
    await this.fetchTaskData();
  },
  computed: {
    deadlineClass() {
      const now = new Date();
      const end = new Date(this.data.eventon);
      if (end < now) return "red--text text--darken-2";
      const diff = (end - now) / (1000 * 60 * 60 * 24);
      return diff < 1 ? "orange--text text--darken-2" : "green--text text--darken-1";
    },
    leads_task_template() {},
    checkBtn() {
      return this.result?.status !== "done";
    },
    results_() {
      let res = this.data?.leads_task_template_data?.results || [];

      return res;
    },
  },
  methods: {
    async fetchTaskData() {
      let api = "/mechti/leads_task_template";
      let id;
      if (this.data.type_ == "task") id = this.data.leads_task_template_id;
      if (!id) return;

      let r = await this.$axios.get(api + "/" + id);
      for (const name in r.data.data) {
        this.$set(this.task_template, name, r.data.data[name]);
      }
      this.results = [...(r.data.data.data?.results?.results || [])];
    },
  },
};
</script>

<style scoped>
.amo-card {
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}
.amo-card:hover {
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.15);
}
</style>
